import { componentsThemeMap } from '../../componentsThemeMap.js';
import '../../ui/Div/index.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function StatChip({
  metric,
  caption,
  style = 'default'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    borderLine = _componentsThemeMap$s.borderLine;
  return /*#__PURE__*/jsxs(Div, {
    width: "100%",
    maxWidth: 327,
    spacingHorizontal: 3,
    flexDirection: "column",
    alignItems: "flex-start",
    borderLeft: "1px solid",
    borderColor: borderLine,
    justifyContent: "flex-start",
    children: [metric && /*#__PURE__*/jsx(Text, {
      as: "span",
      height: 118,
      color: foreground,
      variant: "display1",
      alignItems: "center",
      children: metric
    }), caption && /*#__PURE__*/jsx(Text, {
      as: "label",
      spacingTop: 0.5,
      variant: "caption",
      color: foregroundSecondary,
      children: caption
    })]
  });
}
export { StatChip };
//# sourceMappingURL=StatChip.js.map
